<template>
  <b-dropdown
    :mobile-modal="false"
    style="cursor:pointer"
    position="is-bottom-left"
    append-to-body
    aria-role="menu"
  >
    <b-icon size="is-small" slot="trigger" icon="ellipsis-h"></b-icon>
    <b-dropdown-item @click="qrcode(insight.url_participant)">
      <img src="@/assets/img/icons/qrcode.png" class="icon" alt="icon-qrcode" />
      {{ $t("public.qrcode") }}
    </b-dropdown-item>
    <b-dropdown-item @click="popupParameters(insight.id)">
      <img
        src="@/assets/img/icons/parameters.png"
        class="icon"
        alt="icon-paramters"
      />
      {{ $t("insight.configurer") }}
    </b-dropdown-item>
    <b-dropdown-item @click="shares(insight.id)">
      <img src="@/assets/img/icons/share.png" class="icon" alt="icon-share" />
      {{ $t("insight.shares") }}
    </b-dropdown-item>
    <b-dropdown-item @click="duplicate(insight)">
      <img
        src="@/assets/img/icons/duplicate.png"
        class="icon"
        alt="icon-duplicate"
      />
      {{ $t("insight.duplicate") }}
    </b-dropdown-item>
    <b-dropdown-item
      :disabled="!insight.participants_count"
      @click="exportExcelPdf(insight.url_moderateur, insight.id, insight.name, insight.created_at)"
    >
      <img
        src="@/assets/img/icons/export-icon.png"
        class="icon"
        alt="icon-export"
      />
      {{ $t("insight.exporter") }}
    </b-dropdown-item>
    <b-dropdown-item @click="resetInsight(insight.id)">
      <img
        src="@/assets/img/icons/reset-icon.png"
        class="icon"
        alt="icon-reset"
      />
      {{ $t("common.reset") }}
    </b-dropdown-item>
    <b-dropdown-item
      :disabled="
        $store.state.authentification.connectUserID !== insight.owner_id
      "
      @click="deleteInsight(insight.id)"
    >
      <img
        src="@/assets/img/icons/delete.png"
        class="icon"
        alt="icon-results"
      />
      {{ $t("common.supprimer") }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  name: "ParametersDropdown",
  props: {
    insight: Object,
    cardIndex: Number,
  },
  methods: {
    sendMessageToParent(taskToDo) {
      let message = {
        task: taskToDo,
      };
      window.top.postMessage(message, "*");
    },
    qrcode(insightUrlClient) {
      this.sendMessageToParent("scrollToTop");
      this.$store.commit("MODAL_QRCODE", {
        urlQrCode: process.env.VUE_APP_URL_INSIGHT + "/i-" + insightUrlClient,
        activeModalQrCode: true,
        codeParticipant: insightUrlClient,
      });
    },
    popupParameters(idInsight) {
      this.sendMessageToParent("scrollToTop");
      this.$store.dispatch("getInsight", idInsight);
      this.$store.dispatch("popupToggle");
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        cardList: false,
        parameters: true,
        searchBar: !!this.$store.state.insight.search_query.length,
      });
    },
    shares(insightId) {
      this.sendMessageToParent("scrollToTop");
      this.$store.commit("MODAL_SHARES", {
        insightId: insightId,
        activeModalShares: true,
      });
    },
    duplicate(insight) {
      this.sendMessageToParent("scrollToTop");
      this.$store.commit("MODAL_DUPLICATE", {
        insight: insight,
        activeModalDuplicate: true,
      });
    },
    exportExcelPdf(
      InsightUrlModerateur,
      insightId,
      insightName,
      insightCreatedAT
    ) {
      this.sendMessageToParent("scrollToTop");
      this.$store.commit("MODAL_EXPORTEXCELPDF", {
        insightId: insightId,
        insightName: null,
        insightCreatedAt: null,
        insightUrlModerateur: InsightUrlModerateur,
        activeModalExportExcelPdf: true,
      });
    },
    resetInsight(insightId) {
      this.sendMessageToParent("scrollToTop");
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t("button.annuler"),
        confirmText: this.$i18n.t("button.raz"),
        message: this.$i18n.t("insight.reset"),
        onConfirm: () => this.$store.dispatch("raz_insight", insightId),
      });
    },
    deleteInsight(insightId) {
      this.sendMessageToParent("scrollToTop");
      this.$buefy.dialog.confirm({
        scroll: "clip",
        cancelText: this.$i18n.t("insight.non"),
        confirmText: this.$i18n.t("insight.oui"),
        message: this.$i18n.t("insight.confirmer"),
        onConfirm: () => this.$store.dispatch("delete_insight", insightId),
      });
    },
  },
};
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  vertical-align: center;
}
</style>
